import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=0891fd5a&scoped=true&"
import script from "./BottomBar.vue?vue&type=script&lang=js&"
export * from "./BottomBar.vue?vue&type=script&lang=js&"
import style0 from "./BottomBar.vue?vue&type=style&index=0&id=0891fd5a&prod&lang=css&"
import style1 from "./BottomBar.vue?vue&type=style&index=1&id=0891fd5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0891fd5a",
  null
  
)

export default component.exports